import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { UIEventEmitter } from '../utilitites/ui-events';
import { UIEvents } from '../utilitites/application.constants';
export var ActionComponent = function (_React$Component) {
  _inherits(ActionComponent, _React$Component);

  var _super = _createSuper(ActionComponent);

  function ActionComponent(state, props) {
    var _this;

    _classCallCheck(this, ActionComponent);

    _this = _super.call(this, state, props);
    _this.state = {};
    return _this;
  }

  _createClass(ActionComponent, [{
    key: "onCallEndButtonClicked",
    value: function onCallEndButtonClicked(event) {
      UIEventEmitter.getInstance().dispatch(UIEvents.OnCallEndClicked, {});
      event.preventDefault();
    }
  }, {
    key: "onJoinCall",
    value: function onJoinCall(event) {
      UIEventEmitter.getInstance().dispatch(UIEvents.OnJoinCallClicked, {});
      event.preventDefault();
    }
  }, {
    key: "showMyVideo",
    value: function showMyVideo(event) {
      UIEventEmitter.getInstance().dispatch(UIEvents.OnShowMyVideoClicked, {});
      event.preventDefault();
    }
  }, {
    key: "flipCamera",
    value: function flipCamera(event) {
      UIEventEmitter.getInstance().dispatch(UIEvents.OnFlipCameraClicked, {});
      event.preventDefault();
    }
  }, {
    key: "muteAudio",
    value: function muteAudio(event) {
      UIEventEmitter.getInstance().dispatch(UIEvents.OnMuteAudioClicked, {});
      event.preventDefault();
    }
  }, {
    key: "turnOffVideo",
    value: function turnOffVideo(event) {
      UIEventEmitter.getInstance().dispatch(UIEvents.OnTurnOffVideoClicked, {});
      event.preventDefault();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        id: "videoActionControl",
        className: "col-md-12 no-gutter",
        style: {
          textAlign: 'center',
          background: '#FFF'
        }
      }, !this.props.isCallConnected && !this.props.isWaiting ? React.createElement("button", {
        id: "joinCall",
        className: "btn",
        style: {
          marginRight: 10,
          background: 'none',
          color: 'green'
        },
        onClick: this.onJoinCall.bind(this),
        title: "Join Call"
      }, React.createElement("i", {
        className: "material-icons videoControl"
      }, "call")) : "", this.props.isCallConnected || this.props.isWaiting ? React.createElement("button", {
        id: "endCall",
        className: "btn",
        style: {
          marginRight: 10,
          background: 'none'
        },
        onClick: this.onCallEndButtonClicked.bind(this),
        title: "End Call"
      }, React.createElement("i", {
        className: "material-icons videoControl vcFontColorRed"
      }, "call_end")) : "", this.props.isCallConnected ? React.createElement("button", {
        id: "eyeSlash",
        className: "btn",
        style: {
          marginRight: 10,
          background: 'none'
        },
        onClick: this.showMyVideo.bind(this),
        title: this.props.isShowMyVideoPreviewOff ? "Show My Video Preview" : "Hide My Video Preview"
      }, React.createElement("i", {
        className: "material-icons videoControl " + (this.props.isShowMyVideoPreviewOff ? "vcFontColorAction " : "vcFontColorIndiaOPD")
      }, this.props.isShowMyVideoPreviewOff ? "visibility_off " : "visibility")) : "", this.props.isCallConnected ? React.createElement("button", {
        id: "videoSlash",
        className: "btn",
        style: {
          marginRight: 10,
          background: 'none'
        },
        onClick: this.turnOffVideo.bind(this),
        title: this.props.isVideoOff ? "Turn On Video" : "Turn Off Video"
      }, React.createElement("i", {
        className: "material-icons videoControl " + (this.props.isVideoOff ? "vcFontColorAction " : "vcFontColorIndiaOPD")
      }, this.props.isVideoOff ? "videocam_off " : "videocam")) : "", this.props.isCallConnected ? React.createElement("button", {
        id: "mute",
        className: "btn",
        style: {
          marginRight: 10,
          background: 'none'
        },
        onClick: this.muteAudio.bind(this),
        title: this.props.isOnMute ? "Unmute Audio" : "Mute Audio"
      }, React.createElement("i", {
        className: "material-icons videoControl " + (this.props.isOnMute ? "vcFontColorAction " : "vcFontColorIndiaOPD")
      }, this.props.isOnMute ? "mic_off " : "mic")) : "", this.props.isCallConnected ? React.createElement("button", {
        id: "flipcamera",
        className: "btn",
        style: {
          background: 'none'
        },
        onClick: this.flipCamera.bind(this)
      }, React.createElement("i", {
        className: "material-icons vcFontColorIndiaOPD videoControl",
        style: {
          fontWeight: 'normal'
        }
      }, "flip_camera_ios")) : "");
    }
  }]);

  return ActionComponent;
}(React.Component);